import { CorporateSponsorshipApi } from '@blank/api'
import { apiClient } from 'modules/common/http/apiClient'
import { getAuthorizationHeader } from 'modules/common/lib/api/getAuthorizationHeader'

interface Props {
  corporateId: string
  accessToken: string
}
export const fetchCorporateSponsorship = async ({
  corporateId,
  accessToken,
}: Props) => {
  const apiUrl = `/v1/users/sponsorship/${corporateId}`

  const { data } = await apiClient.get<CorporateSponsorshipApi>(apiUrl, {
    headers: getAuthorizationHeader(accessToken),
  })
  return data
}
